// extracted by mini-css-extract-plugin
module.exports = {"bar":"TasksFilterBar_bar__7A3bT"};